/** How a purchase's attempt is read while it is watched
 *  (`purchase/transport.ts`): when to stop, how often the fallback poll
 *  reads it, and how long to wait after a failure. */

export const terminalPollStatus = (status: unknown) =>
  status === 401 || status === 403 || status === 404;

/** A watched attempt's read the server answers not found. The server said it
 *  exists before the screen watched it, so a not found is a moment it could
 *  not be read (a spine purchase started at Buy read before its
 *  authorization committed: 2 Nov 2026), not yet its loss. */
export const notFoundPollStatus = (status: unknown) => status === 404;

/** How long a watched attempt's reads must go on answering not found before
 *  the screen stops following it: with the failure backoff, its third read,
 *  15 s after the first, however many changes the socket told meanwhile.
 *  Far longer than any write the server commits takes, and short enough
 *  that an attempt truly gone (another fan signed in) is said before the fan
 *  gives up on a screen that does not move. */
export const NOT_FOUND_GRACE_MS = 10_000;

/** How often a watched attempt is read when nothing says it changed. The
 *  API's realtime socket says so as each change commits, so this is the
 *  fallback for a lost message or a socket that cannot connect. */
export const POLL_INTERVAL_MS = 5_000;

/** Back off after consecutive failures so an outage does not hammer the per-IP rate limit. */
export const failureDelay = (failures: number) =>
  Math.min(10_000, POLL_INTERVAL_MS * 2 ** Math.max(0, failures - 1));
